import {
  GuarantorDto,
  GuarantorSearchRequest,
  MedIndexAddRequest,
  MedIndexAddSearchRequest,
  MedIndexAddSearchResponse,
  UpdateGuarantorMedIndexResponse,
  UpdateGuarantorsMedIndexRequest,
  UpsertGuarantorDto
} from 'ts-types/api.types';
import axios from './http';
import { CancelTokenSource } from 'axios';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/guarantors`;

export const getAllGuarantors = (source: CancelTokenSource): Promise<Array<GuarantorDto>> => {
  return axios
      .get(apiUri, {cancelToken: source.token})
      .then(response => response.data);
};

export const getAllGuarantorsForCollectiveBillTrue = (source: CancelTokenSource): Promise<Array<GuarantorDto>> => {
  return axios
      .get(`${apiUri}/collective-bill`, {cancelToken: source.token})
      .then(response => response.data);
};

export const updateGuarantorMedIndex = (request: UpdateGuarantorsMedIndexRequest,
                                        source: CancelTokenSource): Promise<UpdateGuarantorMedIndexResponse> => {
  return axios
      .post(`${apiUri}/medIndexUpdate`, request, {cancelToken: source.token})
      .then(response => response.data);
};

export const searchGuarantors = (guarantorSearchRequest: Partial<GuarantorSearchRequest>,
                                 source: CancelTokenSource): Promise<Array<GuarantorDto>> => {
  return axios
      .post(`${apiUri}/search`, guarantorSearchRequest, {cancelToken: source.token})
      .then(response => response.data)
};

export const searchUpdateGuarantors = (guarantorSearchRequest: Partial<GuarantorSearchRequest>,
                                 source: CancelTokenSource): Promise<Array<GuarantorDto>> => {
  return axios
      .post(`${apiUri}/search-update`, guarantorSearchRequest, {cancelToken: source.token})
      .then(response => response.data)
};

export const getGuarantorData = (guarantorId: number, source: CancelTokenSource): Promise<GuarantorDto> => {
  return axios
      .get(`${apiUri}/${guarantorId}`, {cancelToken: source.token})
      .then((response) => response.data);
};

export const searchGuarantorsForInput = (query: string, source: CancelTokenSource, limit?: number, tariffType?: string): Promise<Array<GuarantorDto>> => {

  const queryParams = {
    query: query,
    tariffType: tariffType,
    limit: limit
  };

  return axios
      .get(apiUri, {cancelToken: source.token, params: queryParams})
      .then(response => response.data)
};

export const findGuarantorById = (id: number, source: CancelTokenSource): Promise<UpsertGuarantorDto> => {
  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const saveGuarantor = (upsertGuarantorDto: Partial<UpsertGuarantorDto>, source: CancelTokenSource): Promise<GuarantorDto> => {
  return axios
      .post(apiUri, upsertGuarantorDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editGuarantor = (id: number, upsertGuarantorDto: Partial<UpsertGuarantorDto>, source: CancelTokenSource): Promise<GuarantorDto> => {
  return axios
      .put(`${apiUri}/${id}`, upsertGuarantorDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteGuarantor = (id: number, source: CancelTokenSource): Promise<GuarantorDto> => {
  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const hasGuarantorCompany = (guarantorId: number, source: CancelTokenSource): Promise<boolean> => {
  return axios
      .get(`${apiUri}/guarantor-company/${guarantorId}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const medIndexAddGuarantors = (request: MedIndexAddRequest,
                                      source: CancelTokenSource): Promise<MedIndexAddSearchResponse> => {
  return axios
      .post(`${apiUri}/guarantor-med-index-add`, request, {cancelToken: source.token})
      .then(response => response.data);
};

export const medIndexAddSearchGuarantors = (request: Partial<MedIndexAddSearchRequest>,
                                            source: CancelTokenSource): Promise<MedIndexAddSearchResponse> => {
  return axios
      .post(`${apiUri}/guarantor-med-index-search`, request, {cancelToken: source.token})
      .then(response => response.data);
};
